import { store } from '@risingstack/react-easy-state';

export interface PromotedFeatures {
  storefront: string[];
  mobile: string[];
  shared: string[];
  growthbook: string[];
  isLoading: boolean;
}

const DEFAULT_FEATURES_STATE: PromotedFeatures = {
  storefront: [],
  mobile: [],
  shared: [],
  growthbook: [],
  isLoading: false,
};

export const featuresToPromoteState = store<PromotedFeatures>(DEFAULT_FEATURES_STATE);

export const setFeaturesToPromoteData = (data: Omit<PromotedFeatures, 'isLoading'>) => {
  featuresToPromoteState.storefront = data.storefront;
  featuresToPromoteState.mobile = data.mobile;
  featuresToPromoteState.shared = data.shared;
  featuresToPromoteState.growthbook = data.growthbook;
};

export const setIsFetchingFeaturesToPromote = (isFetching: boolean) => {
  featuresToPromoteState.isLoading = isFetching;
};

export const hasFeaturesToPromote = (): boolean => {
  return (
    featuresToPromoteState.storefront.length > 0 ||
    featuresToPromoteState.mobile.length > 0 ||
    featuresToPromoteState.shared.length > 0 ||
    featuresToPromoteState.growthbook.length > 0
  );
};
